import React, {Component} from 'react';
import {ChannelLogo} from '../channels/ChannelLogo';
import {CHANNEL_INFO_BY_CHANNEL} from '../channels/channels';
import {withTranslation} from 'react-i18next';


class PlatformPillClass extends Component {

    render() {
        const {channel, count, isSelected, onClick, t} = this.props;
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[channel];
        const channelName = channelInfo ? channelInfo.Spanish : channel;
        const channelClass = channel.toLowerCase();

        const className = [
            'accounts-filter-bar__pill',
            `accounts-filter-bar__pill--${channelClass}`,
            isSelected ? 'accounts-filter-bar__pill--active' : ''
        ].filter(Boolean).join(' ');

        return (
            <button
                className={className}
                onClick={() => onClick(channel)}
                role="checkbox"
                aria-checked={isSelected}
                aria-label={t('agency_accounts_filter.filter_by_platform') + ': ' + channelName}
            >
                <ChannelLogo channel={channel} height={16} width={16} hspace={0} vspace={0} marginLeft={0} padding={0} />
                <span>{count}</span>
            </button>
        );
    }
}

export const PlatformPill = withTranslation()(PlatformPillClass);
